import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';
import { ex } from '@fullcalendar/core/internal-common';


export function* GetPurchaseRequestCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.PURCHASE_REQUEST.GET_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetPurchaseRequestStatusList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.PURCHASE_REQUEST.GET_STATUSES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetPurchaseRequestTypeList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.PURCHASE_REQUEST.GET_REQUEST_TYPES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetPurchaseRequestList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.PURCHASE_REQUEST.LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetPurchaseRequestListById(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.PURCHASE_REQUEST.GET_REQUEST_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SavePurchaseRequest(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.PURCHASE_REQUEST.SAVE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* DeletePurchaseRequest(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.PURCHASE_REQUEST.DELETE+"?PurchaseRequestID="+data.PurchaseRequestID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportPurchaseRequest(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.PURCHASE_REQUEST.EXPORT_PDF, data, true, true);
if (resp.status >= 200 && resp.status < 300 && resp.data ) {
    action && action.callbackSuccess && action.callbackSuccess(resp.data);  
} else {
    action && action.callbackError && action.callbackError(resp.data.message);      
}
} catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
}
}
export function* ExportPurchaseRequestXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.PURCHASE_REQUEST.EXPORT_XLS, data, true,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}       
export function* SaveProcessPurchaseRequest(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.PURCHASE_REQUEST.PROCESS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
